import type { FaireProductEntity } from "../../entity_types/product";

export const p_svpt8uthf7: FaireProductEntity = {
  token: "p_svpt8uthf7",
  type: "product",
  name: "The Greenhouse - Tomato Leaf - 8oz Glass Candle",
  brandToken: "b_sec844xbdh",
  brandName: "Field Kit",
  imageUrl:
    "https://cdn.faire.com/fastly/60044e7c1db5b7625e2d2a652ac5f599d4d25bb9bf689afbf451f351380e08d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edf63cef9ee9f3eaa43e2ec0a5c8fb7aa9c443b76404c2e4b6499f5b8ee5cfd1.jpeg",
    "https://cdn.faire.com/fastly/fb7b69263ba72efa772090450c4e8bcfa4ec8573134452b747ff7735a4d8766e.jpeg",
    "https://cdn.faire.com/fastly/07d702e47f518ad782772502299459db52004c692336cc76c21340979898edc6.jpeg",
  ],
  priceDollars: 18.5,
  description:
    "Dappled sunlight\nDew drops\nA tangle of overgrown vines\n\nTop notes - tomato leaf + coriander\nMid notes - galbanum + jasmine\nBase notes - earth\n\nIngredients\n100% soy wax\nClean burning cotton wick\nFine fragrance oils\nReusable glass jar\n\nSize\n8oz | 227g\n50+ hour burn time",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:08.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
